import React, { lazy } from 'react';
import { Button } from './ui/Button';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function PricingSection() {
  return <section id="pricing" className="py-8 bg-gradient-to-b from-white to-[#FAFAF8]" data-id="element-129">
      <div className="container mx-auto px-4" data-id="element-130">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="max-w-lg mx-auto bg-white rounded-3xl shadow-2xl overflow-hidden border border-gray-100 relative" data-id="element-131">
          {/* Badge */}
          <div className="absolute top-0 right-0 bg-[#F97316] text-white text-xs font-bold px-4 py-2 rounded-bl-xl z-10" data-id="element-132">
            OFERTA ESPECIAL
          </div>

          <div className="p-5 md:p-7 text-center" data-id="element-133">
            {/* Mockup image - small */}
            <div className="flex justify-center mb-3" data-id="element-134">
              <img src="https://cdn.magicpatterns.com/uploads/vbGEfVjJvmxCnAvSKut6dU/MOCKUP_1.png" alt="El Interruptor Digital" className="w-28 h-auto drop-shadow-lg" loading="lazy" decoding="async" width="112" height="112" data-id="element-135" />
            </div>

            <h2 className="text-2xl font-bold text-[#1a1a2e] mb-1 font-montserrat" data-id="element-136">
              Empieza hoy mismo
            </h2>
            <p className="text-gray-500 mb-4 text-sm" data-id="element-137">
              Acceso inmediato en formato PDF
            </p>

            <div className="flex items-center justify-center gap-2 mb-1" data-id="element-138">
              <span className="text-gray-400 line-through text-xl" data-id="element-139">$15.00</span>
              <span className="text-5xl font-extrabold text-[#0ABFBC]" data-id="element-140">
                $6.39
              </span>
            </div>
            <p className="text-sm text-gray-500 mb-4" data-id="element-141">
              Pago único. Sin suscripciones.
            </p>

            <div className="space-y-2 mb-5 text-left" data-id="element-142">
              {['Guía completa en PDF (7 días)', 'Plantillas de acuerdos familiares', 'Lista de chequeo diaria', 'Acceso de por vida'].map((item, i) => <div key={i} className="flex items-center gap-3" data-id="element-143">
                  <div className="w-5 h-5 rounded-full bg-[#0ABFBC]/20 flex items-center justify-center flex-shrink-0" data-id="element-144">
                    <Check className="w-3 h-3 text-[#0ABFBC]" data-id="element-145" />
                  </div>
                  <span className="text-gray-700" data-id="element-146">{item}</span>
                </div>)}
            </div>

            <a href="https://narelaspace.com/cart/47598863450332:1" target="_blank" rel="noopener noreferrer" className="block w-full" onClick={() => {
            if (typeof window !== 'undefined' && window.fbq) {
              window.fbq('track', 'AddToCart', {
                content_name: 'El Interruptor Digital',
                content_type: 'product',
                value: 6.39,
                currency: 'USD'
              });
            }
          }} data-id="element-147">
              <Button variant="primary" size="lg" fullWidth className="mb-2 shadow-xl shadow-orange-500/20" data-id="element-148">
                Sí, quiero recuperar el equilibrio
              </Button>
            </a>

            <p className="text-xs text-gray-400" data-id="element-149">
              Menos de lo que cuesta una salida casual.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}